import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/businesses/show.vue'

export default class extends Controller {
  static values = {
    businessId: String,
    businessName: String,
    accountId: String,
    csrfToken: String
  }

  connect() {
    this.vue = createApp(App, {
      businessId: this.businessIdValue,
      businessName: this.businessNameValue,
      accountId: this.accountIdValue,
      csrfToken: this.csrfTokenValue
    })
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
